// Au logout on vide le localStorage des données liées au COMPTE (households,
// enfants, user, onboarding…) pour éviter qu'elles ne fuitent vers un autre
// compte connecté ensuite sur le même device. Mais certaines clés sont
// *device-level* : elles décrivent l'appareil/l'utilisateur de l'appareil, pas
// le compte, et doivent survivre à une déconnexion/reconnexion.
//
// Avant ce helper, le logout faisait un `localStorage.clear()` brut qui effaçait
// AUSSI ces clés device — d'où le bug : les popups d'info (onboarding tips) déjà
// vues réapparaissaient toutes après une reconnexion.

/** Clés qui décrivent le device/préférences locales, PAS le compte. Préservées
 *  au logout. */
export const DEVICE_LEVEL_KEYS: readonly string[] = [
  'onboarding-tips-dismissed', // popups d'info déjà vues (par device)
  'locale-preferences',        // langue / format date-heure (aussi en DB, mais device-first)
  'user-locale',               // locale résolue au boot
  'harmonia_in_app_review_user-1', // anti-spam de la demande de notation
]

/**
 * Vide le localStorage des données liées au compte tout en préservant les clés
 * device-level (cf. DEVICE_LEVEL_KEYS). Équivaut à `localStorage.clear()` puis
 * restauration des clés exemptées — implémenté en sauvegarde/restauration pour
 * rester robuste quelle que soit la liste des autres clés présentes.
 *
 * @param storage l'implémentation de Storage à nettoyer (défaut: localStorage).
 */
export function clearAccountStorage(storage: Storage = localStorage): void {
  const preserved = new Map<string, string>()
  for (const key of DEVICE_LEVEL_KEYS) {
    const value = storage.getItem(key)
    if (value !== null) preserved.set(key, value)
  }

  storage.clear()

  for (const [key, value] of preserved) {
    storage.setItem(key, value)
  }
}
